import React, { Component } from 'react';
import injectSheet from 'react-jss';
import _ from 'lodash';

import {
  Card, CardBody, Media,
} from 'reactstrap';

const styles = {
  cardContainer: {
    // marginRight: '2rem',
    marginBottom: '2rem',
    boxShadow: '0 0.125rem 0.75rem -0.125rem rgba(0, 0, 0, 0.25)',
    borderRadius: '0.3125rem',
  },
  card: {
    minWidth: '37.5rem',
    maxWidth: '37.5rem',
    borderRadius: '0.3125rem',
  },
  label: {
    fontFamily: 'Lato, Arial',
    fontWeight: 'bold',
    fontSize: '0.875rem',
    color: '#1F1F1F',
    marginBottom: '0.5rem',
  },
  imageWrapper: {
    minWidth: '2rem',
    minHeight: '2rem',
    maxHeight: '2rem',
    maxWidth: '2rem',
    display: 'flex',
    position: 'relative',
    overflow: 'hidden',
    flexShrink: 0,
    alignItems: 'center',
    userSelect: 'none',
    borderRadius: '50%',
    justifyContent: 'center',
    marginRight: '0.5rem',
    marginBottom: '0.5rem',
  },
  image: {
    composes: ['image'],
  },
  participantContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  leaderIcon: {
    composes: ['icon-leader'],
  },
  leaderIconWrapper: {
    top: '4.3rem',
    left: '2.5rem',
    color: '#FFFFFF',
    padding: '0.125rem 0.1875rem',
    borderRadius: '50%',
    position: 'absolute',
    background: '#34A5DA',
    height: '1rem',
    width: '1rem',
    fontSize: '0.625rem',
  },
};


class ParticipantsCard extends Component {
  renderParticipants = (participants) => {
    const { classes } = this.props;
    return participants.map((participant, index) => {
      return (
        <span key={index}>
          <div className={classes.imageWrapper}>
            <Media
              src={participant.image || require(`../assets/userDefaultImage.png`)}
              className={classes.image}
              alt="Generic placeholder image"
            />
          </div>
          {participant.leader ? <span className={classes.leaderIconWrapper}> <i className={classes.leaderIcon}/> </span> : ''}
        </span>
      );
    });
  }

  render() {
    const { classes, participants } = this.props;

    return (
      <div className={classes.cardContainer}>
        <Card className={classes.card}>
          <CardBody>
            <div className={classes.label}> Participants: </div>
            <div className={classes.participantContainer}>
              { this.renderParticipants(_.compact(participants)) }
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default injectSheet(styles)(ParticipantsCard);



// WEBPACK FOOTER //
// ./src/components/ParticipantsCard.js